import { ISingleIdParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class ResumeSubscriptionRequest extends Request<ISingleIdParams, IEmptyResult> {
  constructor(id: string) {
    super('resumeSubscription', {
      id: id
    });
  }
}

